import styled from "styled-components/macro";

export default function BankAccount() {
  return (
    <>
      <Background />
      <Logo className="fas fa-university" />
    </>
  );
}

const Background = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #141e30; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #243b55,
    #141e30
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #243b55,
    #141e30
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
`;

const Logo = styled.span`
  color: white;
  font-size: 60px;
  position: absolute;
  top: 28px;
  right: 8%;
  max-width: calc(100% / 4);

  @media (max-width: 360px) {
    font-size: 52px;
  }
`;
